<template>
  <span>
  <el-button size="mini"
             type="warning"
             :disabled="batchid < 1"
             @click="dialogFormVisible = true"><slot></slot>
  </el-button>
  <el-dialog title="按批次审核"
             :visible.sync="dialogFormVisible">
    <el-form :model="form"
             ref="form"
             :rules="batchRules">
      <el-form-item label="上传Excel"
                    prop="file"
                    label-width="120px">
        <el-upload
          v-loading="loading"
          class="re-el-upload-width-max"
          drag
          :multiple="false"
          ref="uploadThumb"
          :limit="1"
          action
          :before-upload="beforeAvatarUpload"
           accept=".xlsx,.xls"
          :http-request="uploadRequest">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
          <div class="el-upload__tip"
               slot="tip"
               style="margin-top: 0;">只能选择Microsoft Office Excel文件，且不超过2048kb
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="开始时间"
                    label-width="120px"
                    prop="starttime">
        <el-date-picker
          v-model="form.starttime"
          type="datetime"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="工单ID"
                    prop="orderid"
                    label-width="120px">
        <el-input v-model="form.orderid"
                  placeholder="请输入工单id"></el-input>
      </el-form-item>
    </el-form>

    <el-dialog
      width="50%"
      title="提示"
      :visible.sync="innerVisible"
      append-to-body>
      <span>按批次审核是否需要检测?</span>
      <span slot="footer"
            class="dialog-footer">
    <el-button @click="onDetection">不需要</el-button>
    <el-button type="primary"
               @click="onSubmit">需要</el-button>
  </span>

    </el-dialog>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="onOpenInner">确 定
      </el-button>
    </div>
  </el-dialog>
    </span>
</template>

<script>
import { batchRules } from '../../order.rules'

export default {
  components: {},
  props: {
    batchid: String,
  },
  data () {
    return {
      batchRules,
      loading: false,
      dialogFormVisible: false,
      innerVisible: false,
      form: {
        file: null,
        starttime: null,
        order_id: null,
        batch_id: null,
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
    }),
  },
  watch: {
    dialogFormVisible (value) {
      if (!value) {
        this.$refs.uploadThumb.clearFiles()
        Object.assign(this.$data, this.$options.data())
      }
    },
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('选择文件大小不能超过 2MB!')
      }
      return isLt2M
    },
    uploadRequest (obj) {
      this.form.file = obj.file
    },
    onOpenInner () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.innerVisible = true
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    onDetection () {
      let data = new FormData()
      data.append('file', this.form.file)
      data.append('starttime', this.form.starttime)
      data.append('batch_id', this.batchid)

      return request.common('onBatchCheckDetection', data).then((res) => {
        this.$message('检测成功')
        this.dialogFormVisible = false
        this.innerVisible = false
      })
    },
    onSubmit () {
      let data = new FormData()
      data.append('file', this.form.file)
      data.append('starttime', this.form.starttime)
      data.append('order_id', this.form.orderid)
      data.append('batch_id', this.batchid)

      return request.common('onBatchCheckDetection', data).then((res) => {
        this.$message('请前往批量任务中确认')
        this.dialogFormVisible = false
        this.innerVisible = false
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.image-list {
  .image-drop-shadow {
    padding: 5px;
    border: solid 1px #EFEFEF;
  }

  a {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  a:hover img.image-drop-shadow {
    border: solid 1px #CCC;
    -moz-box-shadow: 1px 1px 5px #999;
    -webkit-box-shadow: 1px 1px 5px #999;
    box-shadow: 1px 1px 5px #999;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/order/components/buttons/OrderOnBatchCheckButton.vue